import ADOBEFONTS from "../plugins/adobefont"
import TOGGLE_DRAWER from "../plugins/toggleDrawer"
import PAGETRANSITION from "../plugins/pagetransition"
import CURRENT_NAV from "../plugins/currentNav"
import ANCHORLINK from "../plugins/anchorlink";


const [w,d,l] = [window,document,location]

export default function init () {
  
  d.documentElement.classList.remove('no-js')
  PAGETRANSITION()
  d.documentElement.classList.add('is-loading')
  w.addEventListener('load',()=> d.documentElement.classList.remove('is-loading'))
  w.addEventListener('load',ANCHORLINK)
  CURRENT_NAV('[data-plugin="currentNav"]')
  
  TOGGLE_DRAWER()

  // ADOBEFONTS({
  //   kitId: 'xbe7rqe',
  //   scriptTimeout: 3000,
  //   async: true
  // })


}